import { useTranslation } from 'react-i18next';
import { QueryErrorState } from '@/components/admin/shared/QueryErrorState';
import { LoadingSpinner } from '@/components/common/LoadingSpinner';
import { useTreatmentPlanTemplatesQuery } from '@/hooks/useTreatmentPlanTemplates';
import { PlanTemplatesEditor } from './PlanTemplatesEditor';

export function PlanTemplatesSection() {
  const { t } = useTranslation('plans');
  const templatesQuery = useTreatmentPlanTemplatesQuery();

  if (templatesQuery.isLoading === true) {
    return (
      <div className="py-16 flex justify-center">
        <LoadingSpinner className="w-7 h-7" />
      </div>
    );
  }

  if (templatesQuery.isError === true || templatesQuery.data === undefined) {
    return (
      <QueryErrorState
        onRetry={function retry() {
          templatesQuery.refetch();
        }}
      />
    );
  }

  return (
    <div className="space-y-5">
      <p className="text-xs text-zoomuted">{t('templates.settingsNote')}</p>
      <PlanTemplatesEditor initialTemplates={templatesQuery.data} />
    </div>
  );
}
